import { Button } from "antd";
import React from "react";
import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sendTickerCommand } from "store/reducers/TabsSlice";

interface PartialBlockToastProps {
    message: string;
    onClose: () => void;
}

const PartialBlockToast: React.FC<PartialBlockToastProps> = ({
    message,
    onClose,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleReload = async () => {
        try {
            await dispatch(
                sendTickerCommand({
                    command: "RRO",
                }),
            );
            console.log("Команда RRO успешно отправлена");
        } catch (error) {
            console.error("Ошибка при отправке команды RRO:", error);
        }
    };

    const handleNavigate = () => {
        onClose();
        navigate("/settings");
    };

    const toastElement = (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "16px",
                backgroundColor: "#ff4d4f",
                color: "white",
                zIndex: 10000000000,
                width: "100vw",
                opacity: 0.86,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
        >
            <span>{message || "Произошла ошибка"}</span>
            <div style={{ marginTop: "8px" }}>
                {/* <Button
                    type="primary"
                    onClick={handleNavigate}
                    style={{ marginRight: "8px" }}
                >
                    Перезагрузка
                </Button> */}
                <Button  type="primary" onClick={handleNavigate}>
                    Перейти в настройки
                </Button>
                <Button onClick={onClose}>Закрыть</Button>
            </div>
        </div>
    );

    return createPortal(toastElement, document.body);
};

export default PartialBlockToast;
